import React, { useEffect, useState } from 'react';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Pagination from '@mui/material/Pagination';
import { useMyContext } from '../../../../context/MyContext';
import { FaCcVisa, FaCcMastercard } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import PaginationItem from '@mui/material/PaginationItem';
import { Base_Url, shippingCharges, shippingUserCharges } from '../../../../config/config';
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';
import { Download } from 'lucide-react';

const TopupHistory = () => {
  const [isPageLoading, setIsPageLoading] = useState(false)
  // const [isloading, isSetLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const navigate = useNavigate();
  const [historyData, setHistoryData] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');

  useEffect(() => {
    getShipmentCharges();
  }, [page, limit]);

  const handleNavigation = () => {
    navigate("/dashboard");
  };

  const getShipmentCharges = async () => {
    const apiEndpoint = shippingCharges;
    setIsPageLoading(true);
    const url = `${Base_Url}${apiEndpoint}?page=${page}&limit=${limit}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (data.status === "SUCCESS") {
        setHistoryData(data.data);
        setTotalOrders(data.pagination.totalItems || 0);
        setIsPageLoading(false);
      } else {
        toast.error(data.message);
        setIsPageLoading(false);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
      setIsPageLoading(false);
    }
  };

  const handleDownloadCSV = () => {
    if (historyData.length === 0) {
      toast.error("No data available to download.");
      return;
    }

    const headers = ['Order ID', 'User ID', 'Amount', 'Last Balance', 'Transaction Status', 'Generate Date', 'Description'];
    const csvRows = [headers.join(',')];

    historyData.forEach(row => {
      const amount = row.credit_amount === "0" || row.credit_amount === null ? row.debit_amount : row.credit_amount;
      const rowData = [
        row.order_id,
        row.user_id,
        `${amount}`,
        `${row.closing_balance || 'N/A'}`,
        row.status === "add" ? row.refund_status : row.status,
        row.txn_date,
        `"${row.txn_description || 'N/A'}"`
      ];
      csvRows.push(rowData.join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "shipment_charges.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(historyData.map((_, index) => index));
    }
    setSelectAll(!selectAll);
  };

  const handleRowSelect = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter(i => i !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };


  // const handleDownload = (row) => {
  //   // 1. Extract keys and values
  //   const headers = Object.keys(row);
  //   const values = Object.values(row);

  //   // 2. Create a CSV string
  //   const csvContent = `${headers.join(",")}\n${values.map(v => `"${String(v).replace(/"/g, '""')}"`).join(",")}`;

  //   // 3. Create Blob and trigger download
  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.setAttribute("download", `transaction_${row.order_id || row.id}.csv`);
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(url);
  // };

  const renderTableHeaders = () => {
    const headers = ['Order ID', 'Amount', 'Last Balance', 'Transaction Status', 'Generate Date', 'Description'];

    if (role === 'admin') {
      headers.unshift('User ID');  // Add at the beginning for admin
      // headers.push('Action');
    }

    return headers;
  };

  const getStatusColor = (status, refundStatus) => {
    if (status === "add") {
      switch (refundStatus?.toLowerCase()) {
        case 'completed':
          return isDarkMode ? 'border-white/30 text-white' : 'border-black/30 text-black';
        case 'pending':
          return isDarkMode ? 'border-white/20 text-gray-300' : 'border-black/20 text-gray-600';
        case 'failed':
          return isDarkMode ? 'border-white/40 text-white' : 'border-black/40 text-black';
        default:
          return isDarkMode ? 'border-white/20 text-gray-300' : 'border-black/20 text-gray-600';
      }
    } else {
      return isDarkMode ? 'border-white/15 text-gray-400' : 'border-black/15 text-gray-500';
    }
  };

  const renderTableRow = (row, index) => (
    <tr
      key={row.id}
      className={`dark:bg-black dark:text-white transition-colors border-b ${isDarkMode ? 'border-white/10 hover:bg-white/5' : 'border-black/5 hover:bg-black/[0.02]'} ${index % 2 === 0 ? '' : (isDarkMode ? 'bg-white/[0.02]' : 'bg-black/[0.01]')
        }`}
    >
      {role === 'admin' && (
        <td className="p-2 text-[11px] text-gray-700 dark:text-white font-medium">
          {row.user_id}
        </td>
      )}
      <td className="relative group p-2 text-[11px] font-semibold text-black dark:text-white cursor-pointer transition-colors">
        {row.order_id}
        {/* <div className="absolute left-0 top-full mt-1 hidden group-hover:block bg-gray-900 dark:bg-gray-800 text-white text-[10px] rounded-md px-2 py-1 shadow-lg z-10 whitespace-nowrap">
          💰 View charge details here!
          <div className="absolute -top-1 left-3 w-1.5 h-1.5 bg-gray-900 dark:bg-gray-800 rotate-45"></div>
        </div> */}
      </td>
      <td className="p-2 text-[11px] text-gray-900 font-semibold dark:text-white">
        ₹{row.credit_amount === "0" || row.credit_amount === null ? row.debit_amount : row.credit_amount}
      </td>
      <td className="p-2 text-[11px] text-gray-600 dark:text-gray-300">
        ₹{row.closing_balance || 'N/A'}
      </td>
      <td className="p-2">
        {row.status === "add" ? (
          <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium border ${getStatusColor(row.status, row.refund_status)}`}>
            {row.refund_status}
          </span>
        ) : (
          <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium border ${getStatusColor(row.status)}`}>
            {row.status}
          </span>
        )}
      </td>
      <td className="p-2 text-[11px] text-gray-600 dark:text-gray-300">
        {row.txn_date || 'N/A'}
      </td>
      <td className="p-2 text-[11px] text-gray-600 dark:text-gray-300 max-w-xs">
        <div
          className="truncate hover:text-clip hover:whitespace-normal cursor-help"
          title={row.txn_description || "No description available"}
        >
          {row.txn_description || "N/A"}
        </div>
      </td>

      {/* ➕ Download Action Column */}
      {/* <td className="p-2 text-xs">
        <button
          onClick={() => handleDownload(row)}
          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-xs transition-colors"
        >
          Download
        </button>
      </td> */}
    </tr>
  );


  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div className={`fixed z-20 h-full w-64 md:relative bg-white dark:bg-black dark:text-white mt-4 duration-300 ${window.innerWidth < 768 ? 'top-28' : ''}`}>
            <Sidebar />
          </div>
        )}

        <FullPageLoader
          isLoading={isPageLoading}
          message="Processing your request..."
        />

        <div className={`w-full dark:bg-black dark:text-white bg-gray-200   p-2 border overflow-hidden flex flex-col ${isDarkMode ? 'border-white/15' : 'border-black/10'}`}>
          <div className="flex flex-col sm:flex-row items-center gap-2 mb-3 w-full flex-shrink-0">
            <button
              onClick={handleNavigation}
              className={`flex-1 w-full sm:w-auto text-xs font-bold rounded-lg h-9 flex items-center justify-center transition-colors duration-200 ${isDarkMode ? 'bg-white text-black hover:bg-gray-200' : 'bg-black text-white hover:bg-gray-800'}`}
            >
              <FaCcVisa className="mr-1.5 flex-shrink-0" size={14} />
              <FaCcMastercard className="mr-1.5 flex-shrink-0" size={14} />
              <span className="whitespace-nowrap">Shipments Charges</span>
            </button>

            <button
              onClick={handleDownloadCSV}
              className={`w-full sm:w-auto text-xs font-medium h-9 px-4 rounded-lg flex items-center justify-center transition-colors duration-200 border ${isDarkMode ? 'border-white/25 text-white hover:bg-white/10' : 'border-black/20 text-black hover:bg-black/5'}`}
            >
              <Download className="mr-1.5 w-3.5 h-3.5" />
              <span className="whitespace-nowrap">Download CSV</span>
            </button>
          </div>


          <div className={`overflow-auto custom-scrollbar rounded-lg border flex-1 min-h-0 ${isDarkMode ? 'border-white/15' : 'border-black/10'}`}>
            <table className="min-w-full table-auto bg-white dark:bg-black dark:text-white">
              <thead className={`text-[10px] uppercase tracking-wide sticky top-0 z-10 ${isDarkMode ? 'bg-white text-black' : 'bg-black text-white'}`}>
                <tr>
                  {/* <th className="p-2 text-left font-medium">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="w-4 h-4 ml-1 text-blue-600 bg-white border-gray-300 rounded focus:ring-blue-500"
                    />
                  </th> */}
                  {renderTableHeaders().map((header, index) => (
                    <th key={index} className="p-2 text-left font-semibold">{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="dark:bg-black dark:text-white">
                {historyData.length > 0 ? historyData.map((row, index) => renderTableRow(row, index)) : (
                  <tr>
                    <td colSpan={role === 'admin' ? "8" : "7"} className="text-center p-4 text-[11px] text-gray-500 dark:text-gray-400">
                      No shipping charges history available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="mt-3 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0 flex-shrink-0">
            <span className="text-[11px] text-gray-700 font-bold dark:text-gray-300">{`Total Orders: ${totalOrders}`}</span>
            <select
              id="limit"
              value={limit}
              onChange={handleLimitChange}
              className={`border rounded-md p-1 text-[11px] bg-white dark:bg-black dark:text-gray-200 ${isDarkMode ? 'border-white/20' : 'border-black/20'} ${totalOrders < 10 ? 'cursor-not-allowed opacity-40' : ''}`}
              disabled={totalOrders < 10}
            >
              {totalOrders === 0 ? (
                <option value={0}>0</option>
              ) : (
                <>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={totalOrders}>All</option>
                </>
              )}
            </select>

            <Pagination
              count={Math.ceil(totalOrders / limit)}
              page={page}
              onChange={handlePaginationChange}
              variant="outlined"
              shape="rounded"
              className="pagination"
              size="small"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  className={`mx-1 rounded-md ${item.selected ? (isDarkMode ? 'bg-white text-black' : 'bg-black text-white') : 'text-gray-700 dark:text-gray-300'}`}
                />
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopupHistory;